<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Maintenances"
};
</script>

<style scoped>
</style>
